// @flow
import {
    GET_PRODUCTS,
    MODIFY_PRODUCT_STATE,
    PRODUCT_MODE_CHANGE,
    PRODUCT_MODE_CHANGE_UPDATE_PRODUCT,
    RECEIVE_PRODUCTS,
    REMOVE_PRODUCT,
    REMOVE_PRODUCT_ZONE,
    RENAME_PRODUCT,
    RENAME_PRODUCT_ZONE,
    UNDO_PRODUCT_CHANGE
} from './constants';

import { createAction } from 'redux-actions';

export const modifyProductState = createAction(MODIFY_PRODUCT_STATE);
export const undoProductChange = createAction(UNDO_PRODUCT_CHANGE);
export const getProducts = createAction(GET_PRODUCTS);
export const receiveProducts = createAction(RECEIVE_PRODUCTS);

export const renameProduct = createAction(RENAME_PRODUCT);
export const renameProductZone = createAction(RENAME_PRODUCT_ZONE);
export const removeProduct = createAction(REMOVE_PRODUCT);
export const removeProductZone = createAction(REMOVE_PRODUCT_ZONE);

export const productModeChangeUpdateProduct = createAction(PRODUCT_MODE_CHANGE_UPDATE_PRODUCT);
export const modeSelectorChange = createAction(
    PRODUCT_MODE_CHANGE,
    (productId, mode, currentSchedule, type, defaultTargetTemperature) => ({
        productId,
        mode,
        currentSchedule,
        type,
        defaultTargetTemperature
    })
);



// WEBPACK FOOTER //
// ./src/core/state/products/actions.js